// Maps the "Create New Tenancy" modal payload onto the Property columns that
// actually exist (the CRM has no rental-specific tenancy schema), so marking a
// rental as leased reuses the sale plumbing without a migration:
//   Lease Amount  -> weekly_rent
//   Letting Fee   -> fixed commission (commission_type='fixed', commission_amount)
//   Tenancy Start -> sold_date   (the "leased on" date)
//   Tenancy End   -> settlement_date
//   is_sold=true  -> the completion marker (UI shows "Leased")
//
// Deliberately does NOT set sold_price, so a lease never lands in the sales
// commission/leaderboard reporting.
export const buildLeaseUpdateData = (leaseDetails, today) => {
    const fallbackDate = today || new Date().toISOString().split("T")[0];
    const updateData = { is_sold: true };

    if (typeof leaseDetails.leaseAmount === "number") {
        updateData.weekly_rent = leaseDetails.leaseAmount;
    }
    updateData.sold_date = leaseDetails.tenancyStart || fallbackDate;
    if (leaseDetails.tenancyEnd) {
        updateData.settlement_date = leaseDetails.tenancyEnd;
    }
    if (typeof leaseDetails.lettingFee === "number") {
        updateData.commission_type = "fixed";
        updateData.commission_amount = leaseDetails.lettingFee;
    }
    return updateData;
};
